<template>
  <v-container>
    <v-sheet class="mx-auto transparent" max-width="574">
      <!-- BOC:[error] -->
      <ApiErrorDialog v-if="api.isError" :api="api" />
      <!-- EOC -->

      <v-form @submit.prevent="next">
        <div class="code-input">
          <v-text-field
            autofocus
            focusable
            maxlength="8"
            ref="inputField"
            v-model="code"
            :label="$t('model.prop.schoolCode')"
          ></v-text-field>
        </div>
        <v-card
          class="mb-3 px-3 py-5"
          :class="
            settings.graphics && settings.graphics.mode == 'low'
              ? 'low_plot'
              : 'plot'
          "
        >
          <v-card-text>
            <div class="pt-1">
              <p class="text-h4 mt-3">Code</p>
            </div>
            <div
              v-click-outside="onClickOutside"
              class="show-code d-flex align-center text-center justify-space-between"
              ref="target-element"
            >
              <div
                :style="
                  (!code || code.length == 0) && active ? borderColor : null
                "
                @click="show"
                class="code text-h5"
              >
                <span v-if="code">{{ code.charAt(0) }}</span>
              </div>
              <div
                :style="code && code.length == 1 && active ? borderColor : null"
                @click="show"
                class="code text-h5"
              >
                <span v-if="code">{{ code.charAt(1) }}</span>
              </div>
              <div
                :style="code && code.length == 2 && active ? borderColor : null"
                @click="show"
                class="code text-h5"
              >
                <span v-if="code">{{ code.charAt(2) }}</span>
              </div>
              <div
                :style="code && code.length == 3 && active ? borderColor : null"
                @click="show"
                class="code text-h5"
              >
                <span v-if="code">{{ code.charAt(3) }}</span>
              </div>
              <div
                :style="code && code.length == 4 && active ? borderColor : null"
                @click="show"
                class="code text-h5"
              >
                <span v-if="code">{{ code.charAt(4) }}</span>
              </div>
              <div
                :style="code && code.length == 5 && active ? borderColor : null"
                @click="show"
                class="code text-h5"
              >
                <span v-if="code">{{ code.charAt(5) }}</span>
              </div>
              <div
                :style="code && code.length >= 6 && active ? borderColor : null"
                @click="show"
                class="code text-h5"
              >
                <span v-if="code">{{ code.charAt(6) }}</span>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="green lighten-1"
              x-large
              @click="next"
              :loading="api.isLoading"
              block
              rounded
              class="text-h6"
              style="text-transform: capitalize"
            >
              {{ $t("view.PageEntranceStudentMain.title") }}
            </v-btn>
          </v-card-actions>
          <div class="d-flex my-3">
            <v-spacer></v-spacer>
            <SiteLogo></SiteLogo>
            <v-spacer></v-spacer>
          </div>
        </v-card>
      </v-form>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
let click_sfx = new Audio(require("@/assets/sounds/sfx_click_5.wav"));
export default {
  components: {
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    SiteLogo: () =>
      import(
        /* webpackChunkName: "component-site-logo" */ "@/components/SiteLogo.vue"
      ),
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
      settings: (state) => state.settings.data,
    }),
    borderColor() {
      return " border: solid #66BB6A";
    },
  },
  props: [
    //
  ],
  watch: {
    code: function (val) {
      if (val) {
        this.code = val.toUpperCase();
        this.codeLength = this.code.length;
      }
    },
  },
  data: () => ({
    active: true,
    code: null,
    uid: null,
    codeLength: 0,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    data: [],
  }),
  created() {
    this.$store.dispatch("resetCoin");
    this.$store.dispatch("resetPick");
    this.$store.dispatch("resetSkin");
    this.$store.dispatch("resetApparel");
    this.$store.dispatch("resetTutorial");
    this.$store.dispatch("resetBoss");
    this.$store.dispatch("resetEvent");
    this.$store.dispatch("resetSeries");

    //BOC:[api]
    this.api.method = "get";

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
      this.code = null;
      this.codeLength = 0;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.data = resp;
      let authData = {};
      if (this.auth) {
        authData = this.$_.cloneDeep(this.auth);
      }
      authData.Account = this.data.Account;
      authData.Group = this.data.Group;
      authData.Institution = this.data.Institution;
      this.$store.commit("updateAuth", authData);
      if (this.data.Group.type == "family") {
        let query = {code: this.code}
        if(this.uid) query.uid = this.uid
        this.$router.push({
          name: "PageAccessFamily",
          query: query,
        });
      } else if (this.data.Group.type == "personal") {
        this.$router.push({
          name: "PageAccessClassroom",
          query: { code: this.code },
        });
      } else {
        this.$router.push({
          name: "PageAccessSchool",
          query: { code: this.code },
        });
      }
    };
    //EOC
  },
  mounted() {
    if (this.$route.query.code) {
      this.code = this.$route.query.code.substring(0, 9);
      if (this.$route.query.express && this.$route.query.express == 1 || this.$route.query.uid) {
        this.codeLength = this.code.length;
        if(this.$route.query.uid) {this.uid = this.$route.query.uid}
        this.next();
      }
    } else {
      if (this.auth && this.auth.Group) {
        this.code = this.auth.Group.code;
      }
    }
    if (this.code) {
      this.codeLength = this.code.length;
    }
  },
  methods: {
    fetch() {
      this.api.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/group/" +
        this.code;
      this.$api.fetch(this.api);
    },
    show() {
      this.$refs.inputField.focus();
      this.active = true;
      setTimeout(() => {
        this.$refs["target-element"].scrollIntoView();
      }, 500);
    },
    onClickOutside() {
      this.active = false;
    },
    next() {
      if (!(this.$route.query.express && this.$route.query.express == 1)) {
        click_sfx.play();
        click_sfx.volume = this.settings.audio.sfx * this.settings.audio.master;
      }

      if (this.codeLength == 0) {
        this.api.callbackError(
          this.$t("view.PageEntranceStudentMain.stringCodeEmpty")
        );
      } else if (this.codeLength < 7) {
        this.api.callbackError(
          this.$t("view.PageEntranceStudentMain.stringCodeIncomplete")
        );
      } else {
        this.fetch();
      }
    },
    handleInput(e) {
      if (e.key === "Backspace" || e.key === "Delete") {
        this.code = this.code.substring(0, this.code.length - 1);
        return e.preventDefault();
      }
      const value = e.target.value;
      if (value) {
        return e.preventDefault();
      }
    },
  },
};
</script>
<style scoped>
.position-relative {
  position: relative;
}
.code-input {
  opacity: 0;
  position: absolute;
}
.code {
  background-color: rgb(230, 230, 230);
  width: 100%;
  max-width: 50px;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  -moz-box-shadow: inset 0 0 5px #606060;
  -webkit-box-shadow: inset 0 0 5px #606060;
  box-shadow: inset 2px 2px 5px #8d8d8d;
}
</style>